<template>
  <div id="SignUpForm">
    <form-wizard
      shape="circle"
      color="inherit"
      error-color="#a94442"
      title=""
      subtitle=""
      finish-button-text="Create my ACCOUNT"
      step-size="xs"
    >
      <tab-content
        title="Account Profile"
        icon="ti-user"
        :before-change="() => validateStep('accountProfile')"
      >
        <AccountProfile
          ref="accountProfile"
          :planInformation="planInformation"
          :isForOrganization="isForOrganization"
          @on-validate="mergePartialModels"
        />
      </tab-content>
      <tab-content
        title="Credit Card Info"
        icon="ti-user"
        :before-change="() => doPayment()"
        lazy="true"
      >
        <CreditCardForm
          ref="creditCardForm"
          :planInformation="planInformation"
          :isForOrganization="isForOrganization"
          @on-validate="mergePartialModels"
        />
      </tab-content>

      <template slot="footer" slot-scope="props">
        <div class="wizard-footer">
          <p v-if="apiErrors.GET_PLANS" style="color:#ffffff;">
            GET_PLANS: {{ apiErrors.GET_PLANS }}
          </p>

          <p v-if="apiErrors.REGISTER" style="color:#ffffff;">
            REGISTER: {{ apiErrors.REGISTER }}
          </p>

          <p v-if="apiErrors.LOG_IN" style="color:#ffffff;">
            LOG_IN: {{ apiErrors.LOG_IN }}
          </p>

          <p v-if="apiErrors.PAYMENT" style="color:#ffffff;">
            PAYMENT ERROR: {{ apiErrors.PAYMENT }}
          </p>

          <TMGeneralButton
            v-if="!props.isLastStep && !apiErrors.GET_PLANS && !apiErrors.REGISTER"
            @click.native="props.nextTab()"
            text="NEXT"
          />

          <TMGeneralButton
            v-else-if="!apiErrors.GET_PLANS &&!apiErrors.REGISTER"
            @click.native="doPayment"
            text="CREATE MY ACCOUNT"
          />
        </div>
      </template>
    </form-wizard>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import ShowPassword from "@/components/common/ShowPassword"
import braintree from "braintree-web"
import Api from '@/services/api'
import AccountProfile from "@/components/signUpForm/AccountProfile";
import CreditCardForm from "@/components/signUpForm/CreditCardForm";
import TMGeneralButton from "@/components/common/TMGeneralButton";

export default {
  name: "SignUpForm",
  components: {
    AccountProfile,
    CreditCardForm,
    TMGeneralButton,
  },
  data() {
    return {
      finalModel: {},
      isForOrganization: false, 
      planId: null,
      planInformation: null,
    };
  },
  computed: {
    ...mapState(["apiErrors", "plans"]),
  },
  methods: {
    ...mapActions([
      "CLEAR_API_ERRORS",
      "GET_PLANS",
    ]),
    validateStep(name) {
      var refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    doPayment() {
      return this.$refs["creditCardForm"].payAndSignUp(
        this.finalModel.full_name,
        this.finalModel.email,
        this.finalModel.password,
        this.finalModel.company,
        this.finalModel.phone
      );
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.finalModel = Object.assign({}, this.finalModel, model);
      }
    }
  },
  mounted() {
    this.CLEAR_API_ERRORS();
    // Get plan id from query param
    this.planId = parseInt(this.$route.query.plan) ? parseInt(this.$route.query.plan) : 5;
    this.GET_PLANS().then(() => {
      this.planInformation = this.plans.find(plan => plan.id === this.planId);
      if(this.planInformation.user_type === 'organization') this.isForOrganization = true;
    });
  }
};
</script>
<style lang="less">
@import "../../assets/components/signUpForm/SignUpForm.less";
</style>
